export function toNumericFormat(value) {
  if (value == null)
    return '\u2014';

  return Number(value).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function lastSeveralYears(lastYears) {
  const currentYear = new Date().getFullYear();
  const yearsArr = [];

  for (let i = lastYears; i > 0; --i) {
    yearsArr.push(currentYear - i);
  }

  return yearsArr;
}

export function dateDiff(date1, date2) {
  let years = date2.getFullYear() - date1.getFullYear();
  let months = (years * 12) + date2.getMonth() - date1.getMonth();
  let days = date2.getDate() - date1.getDate();

  years -= date2.getMonth() < date1.getMonth();
  months -= date2.getDate() < date1.getDate();
  days += days < 0 ? new Date(date2.getFullYear(), date2.getMonth() - 1, 0).getDate() + 1 : 0;

  return [years, months, days];
}

export function datePassed(date) {
  const dateToCheck = new Date(date);
  const currentDate = new Date();
  let passed = false;
  // Обнуляем время, чтобы сравнение было только по дате (день, месяц, год)
  dateToCheck.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  if (dateToCheck.getTime() <= currentDate.getTime()) {
    passed = true;
  }
  return passed;
}

// FIXME: надо бы как-то пометить какие из них относятся к 1, 2, 5 и пр.
export function makePlural(iNumber, ...endings) {
  const [v1, v2, v3] = endings;
  let sEnding;

  const lastDigits = iNumber % 100;
  if (lastDigits >= 11 && lastDigits <= 19) {
    sEnding = v3;
  }
  else {
    switch (iNumber % 10) {
      case 1:
        sEnding = v1;
        break;
      case 2:
      case 3:
      case 4:
        sEnding = v2;
        break;
      default:
        sEnding = v3;
    }
  }

  return `${iNumber} ${sEnding}`;
}

export function termActivity(date, turn) {
  const date1 = new Date(date);
  const date2 = new Date();
  const difference = turn ? dateDiff(date2, date1) : dateDiff(date1, date2);
  const differenceYear = difference[0];
  const differenceMonth = difference[1] - (differenceYear * 12);
  const differenceDays = difference[2];
  let output = '';
  if (differenceYear) {
    output += makePlural(differenceYear, 'год', 'года', 'лет');
  }
  if (differenceMonth) {
    output += ` ${makePlural(differenceMonth, 'месяц', 'месяца', 'месяцев')}`;
  }
  if (differenceDays && !differenceMonth) {
    output += ` ${makePlural(differenceDays, 'день', 'дня', 'дней')}`;
  }
  return output;
}

export function notEmptyObject(obj) {
  if (obj == null)
    return false;

  // eslint-disable-next-line no-unreachable-loop
  for (const k in obj) {
    return true;
  }

  return false;
}

const shortToLongCompanyNameRegexes = [
  // FIXME: случайно вытащил из интернета, в окопф справочнике не нашёл
  ['^ИП', 'Индивидуальный предприниматель'],
  ['^ООО', 'Общество с ограниченной ответственностью'],
  ['^АО', 'Акционерное общество'],
  ['^ЗАО', 'Закрытое акционерное общество'],
  ['^ОАО', 'Открытое акционерное общество'],
  ['^ПАО', 'Публичное акционерное общество'],
  ['^НКО', 'Некоммерческая организация'],
  ['^ОДО', 'Общество с дополнительной ответственностью'],
  ['^ПТ', 'Полное товарищество'],
  ['^КТ', 'Коммандитное товарищество'],
  ['^ПК', 'Производственный кооператив'],
];
export function transformShortCompanyNameToLong(companyName) {
  if (typeof companyName !== 'string')
    return null;

  const idx = shortToLongCompanyNameRegexes.findIndex(([regexPattern]) => new RegExp(regexPattern).test(companyName));
  if (idx === -1)
    return companyName;

  const [regexPattern, textToReplace] = shortToLongCompanyNameRegexes[idx];
  return companyName.replace(new RegExp(regexPattern), textToReplace);
}

export function removeCompanyOkopfFromText(text) {
  if (typeof text !== 'string' || !text?.length)
    return null;

  for (const [pattern] of shortToLongCompanyNameRegexes) {
    const regex = new RegExp(pattern);
    if (regex.test(text)) {
      return text.replace(regex, '');
    }
  }

  return text;
}

/**
 * @param {string} access_key base64 string
 * @returns String
 */
export function prepareDownloadKeyAsLink(access_key) {
  return `${__API_URL__}file/get/?access_key=${encodeURIComponent(access_key)}`;
}

export function getDownloadPageUrl({ type, value, companyid, scope }) {
  // FIXME: динамически подставлять ссылку на entry - использовать define от vite?
  const downloadPageUrl = new URL('/download_page.html', document.location);
  downloadPageUrl.searchParams.append('type', type);
  downloadPageUrl.searchParams.append('value', value);
  companyid && downloadPageUrl.searchParams.append('cid', companyid);
  scope && downloadPageUrl.searchParams.append('scope', scope);

  return downloadPageUrl.toString();
}

export function tryToBlankWindow(url) {
  if (window.open(url, '_blank') == null) {
    return Promise.reject(new Error('Не удалось открыть новое окно ссылки, возможно браузер ограничивает это действие'));
  }

  return Promise.resolve();
}

export function transformSizeInBytesToHuman(sizeInBytes) {
  let postfix, size;

  if (sizeInBytes > 1_048_576) {
    // 1MB or more
    postfix = 'мегабайт';
    size = sizeInBytes / 1_048_576;
  }
  else if (sizeInBytes > 1024) {
    // 1KB or more
    postfix = 'килобайт';
    size = sizeInBytes / 1024;
  }
  else {
    postfix = 'байт';
    size = sizeInBytes;
  }

  return `${Math.floor(size).toString()} ${postfix}`;
}

/**
 * @param {number} valueHundred
 */
export function transformNumberToPercentString(valueHundred) {
  if (valueHundred == null)
    return '\u2014';

  if (typeof valueHundred !== 'number') {
    valueHundred = Number(valueHundred);
  }

  return `${valueHundred.toLocaleString('ru', { maximumFractionDigits: 2 })}%`;
}

/**
 * Полифилл для findLast
 * @param {Array} array
 * @param {Function} predicate
 * @returns any
 */
export function findLast(array, predicate) {
  if (!Array.isArray(array) || !array.length)
    return undefined;

  if (typeof array.findLast === 'function') {
    return array.findLast(predicate);
  }

  for (let i = array.length - 1; i >= 0; --i) {
    const item = array[i];
    if (predicate(item, i, array)) {
      return item;
    }
  }

  return undefined;
}

export function securityViewText(item) {
  const output = [];

  item.$extra.has_guarantor && output.push('Гарантия выкупа');
  item.project.ispledge !== 'N' && output.push('Залог');
  item.project.issurety !== 'N' && output.push('Поручительство');

  return output.length ? output.join(', ') : '\u2014';
}

/**
 * Get a random integer between `min` and `max`.
 *
 * @param {number} min - min number
 * @param {number} max - max number
 * @return {number} a random integer
 */
export function getRandomInt(min, max) {
  return Math.floor((Math.random() * (max - min + 1)) + min);
}

// FIXME: перетащить trap-focus в composable
/**
 * @param {Node[]} list
 * @returns {HTMLElement[]} Список элементов попавших под исключение для focus
 */
export function setTrapFocus(...list) {
  const trapFocusElements = [];

  const iterateNodes = Array.isArray(list[0]) ? list[0] : list;
  for (const trapNode of iterateNodes) {
    if (!trapNode)
      continue;

    let currentElement = trapNode.parentElement;
    while (currentElement != null) {
      for (const children of currentElement.children) {
        if (children === trapNode || iterateNodes.some((node) => children.contains(node)))
          continue;
        if (children.inert || children.getAttribute('tabindex') === '-1')
          continue;
        if (children === document.head)
          continue;
        if ('disallowInert' in children.dataset)
          continue;

        children.setAttribute('inert', '');
        children.setAttribute('tabindex', '-1');

        trapFocusElements.push(children);
      }

      currentElement = currentElement.parentElement;
    }
  }

  return trapFocusElements;
}

/**
 * @param {Array<HTMLElement>} trapFocusElements
 */
export function removeTrapFocus(trapFocusElements) {
  for (const focusElement of trapFocusElements) {
    if (!focusElement)
      continue;

    focusElement.removeAttribute('inert');
    focusElement.removeAttribute('tabindex'); // TODO: проверять что до этого не было установлено значение (>=0, ...)
  }
}

// FIXME: убрать отсюда экспорты как можно скорее
export { makeCurrency, makeCurrencyWithShortGroup, makeRub } from '@/shared/money';
export { formatDate, getZeroBasedMonthLabel, parseDatetimeString, tryConvertYMDToDMYRussian, unformatDate } from '@/utils/date';
export { unformatPhone as clearPhone, formatPhone } from '@/utils/phone';
